import _ from "underscore";
import i18n from '../../i18n.js';

export const scheduleTypes = {
  DAYLY: {
    id: "DAILY",
    text: i18n.t('notification.schedule.detail.types.daily')
  },
  WEEKLY: {
    id: "WEEKLY",
    text: i18n.t('notification.schedule.detail.types.weekly')
  },
  MONTHLY: {
    id: "MONTHLY",
    text: i18n.t('notification.schedule.detail.types.monthly')
  },
  IMMEDIATELY: {
    id: "IMMEDIATELY",
    text: i18n.t('notification.schedule.detail.types.immediately')
  },
};

export const scheduleTypeDataSourceConfig = {
  store: {
    type: "array",
    data: _.values(scheduleTypes),
    key: "id"
  },
  map: rec => _.extend({ value: rec.id }, rec)
}

export const weekDays = {
  MON: {
    id: "MON",
    name: i18n.t('notification.schedule.detail.weekdays.mon')
  },
  TUE: {
    id: "TUE",
    name: i18n.t('notification.schedule.detail.weekdays.tue')
  },
  WED: {
    id: "WED",
    name: i18n.t('notification.schedule.detail.weekdays.wed')
  },
  THU: {
    id: "THU",
    name: i18n.t('notification.schedule.detail.weekdays.thu')
  },
  FRI: {
    id: "FRI",
    name: i18n.t('notification.schedule.detail.weekdays.fri')
  },
  SAT: {
    id: "SAT",
    name: i18n.t('notification.schedule.detail.weekdays.sat')
  },
  SUN: {
    id: "SUN",
    name: i18n.t('notification.schedule.detail.weekdays.sun')
  }
};

export const weekDaysArr = [
  {
    id: "MON",
    text: i18n.t('notification.schedule.detail.weekdays.mon')
  },
  {
    id: "TUE",
    text: i18n.t('notification.schedule.detail.weekdays.tue')
  },
  {
    id: "WED",
    text: i18n.t('notification.schedule.detail.weekdays.wed')
  },
  {
    id: "THU",
    text: i18n.t('notification.schedule.detail.weekdays.thu')
  },
  {
    id: "FRI",
    text: i18n.t('notification.schedule.detail.weekdays.fri')
  },
  {
    id: "SAT",
    text: i18n.t('notification.schedule.detail.weekdays.sat')
  },
  {
    id: "SUN",
    text: i18n.t('notification.schedule.detail.weekdays.sun')
  }
];

export const weekDayDataSourceConfig = {
  store: {
    type: "array",
    data: _.values(weekDays),
    key: "id"
  },
  map: rec => _.extend({ value: rec.id }, rec)
}